module.exports = __webpack_public_path__ + "static/kobe-2-9fa99c897e86b1901499569c9d7e016e.jpg";